import { Navigate, Outlet } from 'react-router-dom';

import pages from 'constants/pages';

import { useReduxSelector } from 'hooks/useReduxSelector';

import authSelectors from 'store/slices/auth/selectors';

const PrivateRouteWrapper = (): JSX.Element => {
  const isSigned = useReduxSelector(authSelectors.token);
  return isSigned ? <Outlet /> : <Navigate replace to={pages.auth.signIn} />;
};

export default PrivateRouteWrapper;
